import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { DataPreview, Divider, List, ListItem, Paragraph, Skeleton } from '@fs/zion-ui'
import { formatDate, treeStatusKeyMap } from '../../../helpers'
import { useGenealogyTreesContext } from '../GenealogyTreesProvider'
import GenealogyTreeMenuAction from './GenealogyTreeMenuAction'
import useGenealogyTreeMenu from './useGenealogyTreeMenu'

export default function GenealogyMobileTable() {
  const [t] = useTranslation()
  const { trees } = useGenealogyTreesContext()
  const { menuButtonProps, genealogyActionsOverlay, onMenuClick } = useGenealogyTreeMenu()

  return (
    <DataPreview.Provider loading={!trees}>
      <DataPreview.Loading>
        <Skeleton.ListItem hasEndIcon dense />
        <Skeleton.ListItem hasEndIcon dense />
      </DataPreview.Loading>
      <DataPreview.Ready>
        <List>
          {trees?.map((tree, index) => {
            return (
              <Fragment key={tree.treeUri}>
                <ListItem
                  emphasized
                  overline={formatDate(tree.createDate)}
                  primaryText={tree.name}
                  secondaryText={
                    <>
                      {t('tree-import.people.label', { number: tree.personCount })}
                      <Paragraph size="xs">{t(treeStatusKeyMap[tree.treeStatus])}</Paragraph>
                    </>
                  }
                  endElement={
                    <GenealogyTreeMenuAction menuButtonProps={menuButtonProps} onMenuClick={onMenuClick} tree={tree} />
                  }
                />

                {index !== trees.length - 1 && <Divider />}
              </Fragment>
            )
          })}
        </List>
        {genealogyActionsOverlay}
      </DataPreview.Ready>
    </DataPreview.Provider>
  )
}
